import React from "react";
import {
  getHoursMinutesTime,
  trimDoubleQuotes,
} from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageDateCategories from "./MessageDateCategories";

const MessageSupport = ({ data, time, messagesList, index, currentlyItem }) => {
  return (
    <div className={"msg msg-bot-holder"}>
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={messagesList}
        index={index}
        currentlyItem={currentlyItem}
      />
      <div className="msg-wrapper">
        {data?.text && <div className="msg-text">{trimDoubleQuotes(data.text)}</div>}
        <div className={"msg-avatar-bg"}>
          <div className={"msg-avatar-holder"}>
            <AvatarPreview isSvg={false} src={7} />
          </div>
        </div>
        <div className={"msg-time"}> {time && getHoursMinutesTime(time)} </div>
      </div>
    </div>
  );
};

export default MessageSupport;
